import { Box, Stack, TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MotionContainer from '../../../../components/FramerMotion/MotionContainer';
import { motion } from 'framer-motion';
import useResponsive from '../../../../Hooks/useResponsive';
import { AddButton, DeleteButton, SubmitButton, UpdateButton } from '../../../../components/mui/Buttons/Buttons';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { deleteSubject } from '../../../../redux/features/cartSlice';
import { CART_AED_TO_INR_VALUE } from '../../../../utils/constants/GlobalStaticData';

const CartItemSubjectNew = ({ setAvailableCartItems, item, update, setTotalCourses, handleClose }) => {
  const mdUp = useResponsive('up', 'md');
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { subjects } = useSelector((state) => state.cro);
  const [preferences, setPreferences] = useState([
    { subjectId: '', amountInr: '', amountAed: '', inrForAed: CART_AED_TO_INR_VALUE },
  ]);
  const [currencyType, setCurrencyType] = useState('');

  const [disableValidation, setDisableValidation] = useState(false);
  const [projectValidation, setProjectValidation] = useState(false);
  const [saleAmtValidation, setSaleAmtValidation] = useState(false);

  // --------------------------------------------------------------------------

  useEffect(() => {
    if (item) {
      const { MRP, selectedCurrency } = item;

      let total = 0;

      if (Array.isArray(preferences)) {
        if (selectedCurrency === 1) {
          total = preferences.reduce((sum, item) => sum + Number(item.amountInr || 0), 0);
        } else if (selectedCurrency === 2) {
          total = preferences.reduce((sum, item) => sum + Number(item.amountAed || 0), 0);
        }
      }
      if (total && parseFloat(MRP) === total) {
        setSaleAmtValidation(false);
      } else if (total) {
        setSaleAmtValidation(true);
      } else setSaleAmtValidation(false);
    }
  }, [item, preferences]);
  // -----------------------------------------------------------------------------
  const handleChange = (event) => {
    setCurrencyType(event.target.value);
  };

  useEffect(() => {
    if (open && item && !update) {
      setCurrencyType(item.selectedCurrency);
      setPreferences(
        item?.subjects && item?.subjects?.length > 0
          ? JSON.parse(JSON.stringify(item.subjects))
          : [{ subjectId: '', amountInr: '', amountAed: '', inrForAed: CART_AED_TO_INR_VALUE }]
      );

      if ((!update && item.projectId == 2) || item.projectId == 4) {
        if (item?.selectedCurrency == 1) {
          setPreferences([{ subjectId: -1, amountInr: item.MRP, amountAed: '' }]);
        } else if (item?.selectedCurrency == 2) {
          setPreferences(
            item?.subjects && item?.subjects?.length > 0
              ? JSON.parse(JSON.stringify(item.subjects))
              : [
                  {
                    subjectId: -1,
                    amountInr: item?.aedInrAmt ? item?.aedInrAmt * item.MRP : '',
                    amountAed: item.MPR,
                  },
                ]
          );
        } else if (item?.selectedCurrency == 3) {
          setPreferences(
            item?.subjects && item?.subjects?.length > 0
              ? JSON.parse(JSON.stringify(item.subjects))
              : [
                  {
                    subjectId: -1,
                    amountInr: item.MRP,
                    amountAed: '',
                  },
                ]
          );
        }
        setDisableValidation(true);
      } else {
        setDisableValidation(true);
      }
    }
    if (item.projectId == 2 || item.projectId == 4) {
      setProjectValidation(true);
    } else {
      setProjectValidation(false);
    }
  }, [open, item, update]);
  // -------------------------------------------------

  useEffect(() => {
    if (open && item && update) {
      setCurrencyType(item.selectedCurrency);
      setPreferences(
        item?.subjects && item?.subjects?.length > 0
          ? JSON.parse(JSON.stringify(item.subjects))
          : [{ subjectId: '', amountInr: '', amountAed: '', inrForAed: '' }]
      );

      if ((update && item.projectId == 2) || item.projectId == 4) {
        if (item?.selectedCurrency == 1) {
          setPreferences([{ subjectId: -1, amountInr: item.MRP, amountAed: '' }]);
        } else if (item?.selectedCurrency == 2) {
          setPreferences(
            item?.subjects && item?.subjects?.length > 0
              ? JSON.parse(JSON.stringify(item.subjects))
              : [
                  {
                    subjectId: -1,
                    amountInr: item?.aedInrAmt ? item?.aedInrAmt * item.MRP : '',
                    amountAed: item.MRP,
                  },
                ]
          );
        } else if (item?.selectedCurrency == 3) {
          setPreferences(
            item?.subjects && item?.subjects?.length > 0
              ? JSON.parse(JSON.stringify(item.subjects))
              : [
                  {
                    subjectId: -1,
                    amountInr: item.MRP,
                    amountAed: '',
                  },
                ]
          );
        }
        setDisableValidation(true);
      } else {
        setDisableValidation(true);
      }
    }
    if (item.projectId == 2 || item.projectId == 4) {
      setProjectValidation(true);
    } else {
      setProjectValidation(false);
    }
  }, [open, item, update]);

  // -------------------------------------------------------

  const handleRemovePreference = (index) => {
    if (update) {
      const data = preferences[index];
      const dispatchData = { subjectId: data.subjectId, cartId: item.cartId };
      dispatch(deleteSubject(dispatchData)).then((res) => {
        if (res.payload.status === 'failed' || res.payload.status === 'error') {
          enqueueSnackbar(res.payload.message, { variant: 'error' });
        } else if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          const newPreferences = preferences.filter((_, i) => i !== index);
          setPreferences(newPreferences);
        }
      });
    } else {
      const newPreferences = preferences.filter((_, i) => i !== index);
      setPreferences(newPreferences);
    }
  };

  const handleTimeChange = (index, field, newValue) => {
    const newPreferences = [...preferences];
    newPreferences[index][field] = newValue;
    if (field === 'amountAed') {
      const aedValue = parseFloat(newValue) || 0;
      newPreferences[index].amountInr = aedValue * CART_AED_TO_INR_VALUE;
    }
    setPreferences(newPreferences);
  };

  const handleAddPreference = () => {
    setPreferences((prevPreferences) => [
      ...prevPreferences,
      { subjectId: '', amountInr: '', amountAed: '', inrForAed: '' },
    ]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validation = preferences.some((item) => {
      if ((currencyType && currencyType == 1) || currencyType == 3) {
        return item.amountInr == '' || item.subjectId == '' || item.amountInr == 0;
      } else {
        return item.amountAed == '' || item.amountInr == '' || item.subjectId == '' || item.amountInr == 0;
      }
    });
    if (!validation) {
      if (update) {
        setAvailableCartItems((prevArray) =>
          prevArray.map((cartItem) =>
            cartItem.id === item.id
              ? {
                  ...cartItem,
                  subjects: preferences,
                  currencyType: currencyType,
                }
              : cartItem
          )
        );
        setOpen(false);
        enqueueSnackbar('Subject updated Successfully...!', {
          variant: 'success',
        });
        handleClose();
      } else {
        setTotalCourses((prevArray) =>
          prevArray.map((cartItem) =>
            cartItem.id === item.id
              ? {
                  ...cartItem,
                  subjects: preferences,
                  currencyType: currencyType,
                }
              : cartItem
          )
        );
        enqueueSnackbar('Subject added Successfully...!', {
          variant: 'success',
        });
        setOpen(false);
        handleClose();
      }
    } else {
      enqueueSnackbar('Some fields are empty...!', {
        variant: 'error',
      });
    }
  };
  // const handleInrChange = (e) => {
  //   const { value } = e.target;
  //   setInrForAed(value);
  // };

  return (
    <Box>
      <GlobalDialog
        title={'Add Subjects'}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={'md'}
        closeButton={true}
        popupButton={
          <>
            {update ? (
              <UpdateButton size={'small'} action={() => setOpen(true)}>
                Update subject
              </UpdateButton>
            ) : (
              <AddButton size={'small'} action={() => setOpen(true)}>
                Add Subject
              </AddButton>
            )}
          </>
        }
        content={
          <>
            {open ? (
              <form>
                {item.paidAmt ? (
                  <>
                    <Stack direction={'column'} spacing={2}>
                      {/* <AnimatePresence> */}
                      <motion.div
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 100 }}
                        transition={{ duration: 0.5 }}
                      >
                        <Box>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Currency Type</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              disabled={disableValidation}
                              required
                              value={currencyType}
                              label="Currency Type"
                              onChange={handleChange}
                            >
                              <MenuItem value={1}>INR</MenuItem>
                              <MenuItem value={2}>AED</MenuItem>
                              <MenuItem value={3}>AED To INR</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </motion.div>
                      {currencyType ? (
                        <Box>
                          {preferences?.map((pref, index) => (
                            <motion.div
                              key={index}
                              initial={{ opacity: 0, x: -100 }}
                              animate={{ opacity: 1, x: 0 }}
                              exit={{ opacity: 0, x: 100 }}
                              transition={{ duration: 0.5 }}
                            >
                              <Stack direction={mdUp ? 'row' : 'column'} spacing={1} alignItems="center" sx={{ pb: 2 }}>
                                <MotionContainer delay={1}>
                                  <Box sx={{ width: '100%' }}>
                                    <Box sx={{ width: '100%' }}>
                                      <Autocomplete
                                        disablePortal
                                        disabled={item.projectId == 2 || item.projectId == 4 ? true : false}
                                        name={`subject-${index}`}
                                        id={`autocomplete-subject-${index}`}
                                        options={[{ subjectId: -1, subjectName: 'NA' }, ...subjects]}
                                        getOptionLabel={(option) => option.subjectName || ''}
                                        value={
                                          [
                                            {
                                              subjectId: -1,
                                              subjectName: 'NA',
                                            },
                                            ...subjects,
                                          ].find((item) => item.subjectId === pref.subjectId) || null
                                        }
                                        onChange={(e, option) => {
                                          const newPreferences = [...preferences];
                                          newPreferences[index].subjectId = option?.subjectId || '';
                                          setPreferences(newPreferences);
                                        }}
                                        renderInput={(params) => (
                                          <TextField {...params} required fullWidth label="Subject" />
                                        )}
                                      />
                                    </Box>
                                  </Box>
                                </MotionContainer>
                                <MotionContainer delay={0.7}>
                                  <Box sx={{ width: '100%' }}>
                                    <TextField
                                      fullWidth
                                      required
                                      disabled={projectValidation || currencyType == 2}
                                      type="number"
                                      onWheel={(event) => event.target.blur()}
                                      label="Amount INR (without discount and admission fee)"
                                      value={pref.amountInr}
                                      onChange={(e) => handleTimeChange(index, 'amountInr', e.target.value)}
                                    />
                                  </Box>
                                </MotionContainer>
                                {currencyType == 1 || currencyType == 3 ? null : (
                                  <MotionContainer delay={0.5}>
                                    <Box sx={{ width: '100%' }}>
                                      <TextField
                                        fullWidth
                                        required
                                        disabled={projectValidation}
                                        type="number"
                                        onWheel={(event) => event.target.blur()}
                                        label="Amount AED (without discount)"
                                        value={pref.amountAed}
                                        onChange={(e) => handleTimeChange(index, 'amountAed', e.target.value)}
                                      />
                                    </Box>
                                    {currencyType === 2 ? (
                                      <MotionContainer delay={0.4}>
                                        <Box sx={{ width: '100%', pt: 1 }}>
                                          <TextField
                                            fullWidth
                                            type="number"
                                            disabled
                                            label="Enter INR amount for 1 AED"
                                            value={pref.inrForAed || ''}
                                            onWheel={(event) => event.target.blur()}
                                            onChange={(e) => {
                                              const multiplierValue = parseFloat(e.target.value) || 0;
                                              const newPreferences = [...preferences];
                                              const amountAed = parseFloat(newPreferences[index].amountAed) || 0;

                                              newPreferences[index].inrForAed = multiplierValue;
                                              newPreferences[index].amountInr = (multiplierValue * amountAed).toFixed(
                                                2
                                              );

                                              setPreferences(newPreferences);
                                            }}
                                          />
                                        </Box>
                                      </MotionContainer>
                                    ) : null}
                                  </MotionContainer>
                                )}

                                {projectValidation ? null : (
                                  <DeleteButton size="small" action={() => handleRemovePreference(index)} />
                                )}
                              </Stack>
                            </motion.div>
                          ))}

                          {/* </AnimatePresence> */}
                          {projectValidation ? null : (
                            <Box>
                              <AddButton size="small" action={handleAddPreference}>
                                Add subject
                              </AddButton>
                            </Box>
                          )}
                        </Box>
                      ) : null}
                    </Stack>
                    {/* {(currencyType == 2 && item.projectId == 2) ||
                item.projectId == 4 ? (
                  <MotionContainer delay={0.5}>
                    <Box sx={{ width: "100%" }}>
                      <TextField
                        fullWidth
                        required
                        type="number"
                        onWheel={(event) => event.target.blur()}
                        label="INR amount corresponding to 1 AED"
                        value={inrForAed}
                        onChange={handleInrChange}
                      />
                    </Box>
                  </MotionContainer>
                ) : null} */}
                    <Box p={2}>
                      {saleAmtValidation ? <Alert severity="error"> The sale amount does not match...!</Alert> : null}
                    </Box>
                    {currencyType ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          pt: 2,
                        }}
                      >
                        <SubmitButton disabled={saleAmtValidation} type={'submit'} action={handleSubmit}>
                          Add Subject
                        </SubmitButton>
                      </Box>
                    ) : null}
                  </>
                ) : (
                  <Alert severity="warning">Please fill amount...!</Alert>
                )}
              </form>
            ) : null}
          </>
        }
      />{' '}
    </Box>
  );
};

export default CartItemSubjectNew;
